import axios from "axios";
import { getAPIUrl } from "../../../Constants.ts";
import { EmailConfigModel, EmailTemplateModel, UserRequestFlow } from "./_model";

const API_URL = getAPIUrl();

const UPSERT_EMAIL_CONFIG = `${API_URL}/values/UpsertEmailConfig`;
const GET_EMAIL_CONFIG = `${API_URL}/values/GetEmailConfig`;
const UPSERT_EMAIL_TEMPLATE = `${API_URL}/values/UpsertEmailTemplate`;
const GET_EMAIL_TEMPLATE = `${API_URL}/values/GetEmailTemplate`;
const GET_ALLOWED_FLOWS = `${API_URL}/values/GetAllFlows`;
const UPSERT_ACTIVE_FLOW = `${API_URL}/values/UpsertFlow`;

export function GetAllowedFlows() {
    return axios.get<UserRequestFlow[]>(GET_ALLOWED_FLOWS);
}
export function UpsertActiveFlow(request: UserRequestFlow[]) {
    return axios.post<string>(UPSERT_ACTIVE_FLOW, request);
}

export function UpsertEmailConfig(request: EmailConfigModel) {
    return axios.post<number>(UPSERT_EMAIL_CONFIG, request)
}

export function GetEmailConfig(emailConfigID: number) {
    return axios.get<EmailConfigModel[]>(GET_EMAIL_CONFIG + "?emailConfigID=" + emailConfigID);
}

export function UpsertEmailTemplate(request: EmailTemplateModel) {
    return axios.post<number>(UPSERT_EMAIL_TEMPLATE, request)
}

export function GetEmailTemplate(emailTemplateID: number) {
    return axios.get<EmailTemplateModel[]>(GET_EMAIL_TEMPLATE + "?emailTemplateID=" + emailTemplateID);
}